import {
  SET_DEFAULT_SETTING,
  AppSettingActionType,
  SET_ACTIVE_SIDEBAR,
} from "./app-setting.models";

export function setDefaultAppSetting(): AppSettingActionType {
  return {
    type: SET_DEFAULT_SETTING,
  };
}

export function setActiveSidebar(activeValue: string): AppSettingActionType {
  return {
    type: SET_ACTIVE_SIDEBAR,
    activeValue,
  };
}
